<template>
    <div class="d-flex justify-content-center align-items-center vh-100">
        <div class="col-md-5 centered-div">
            <div class="">
                <div class="text-center mb-3">
                    <img src="@/assets/logo1.png" height="100" alt="Logo" loading="lazy" />
                </div>

                <h2 class="text-center mb-3 text-primary">INSCRIPTION</h2>
                <form @submit.prevent="register()">
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="fa-solid fa-user"></i>
                            </span>
                        </div>
                        <input placeholder="Nom" type="text" class="form-control form-control-lg" v-model="form.nom"
                            required>
                    </div>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="fa-solid fa-user"></i>
                            </span>
                        </div>
                        <input placeholder="Prenom" type="text" class="form-control form-control-lg"
                            v-model="form.prenom" required>
                    </div>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="fa-solid fa-phone"></i>
                            </span>
                        </div>
                        <input placeholder="Telephone" type="text" class="form-control form-control-lg"
                            v-model="form.telephone1" required>
                    </div>
                    <!-- <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="fa-solid fa-envelope"></i>
                            </span>
                        </div>
                        <input placeholder="Adresse email" type="email" class="form-control form-control-lg"
                            v-model="form.email">
                    </div> -->
                    

                    <div class="mb-0 text-center">
                        <button type="submit" class="btn btn-lg btn-block btn-primary mb-3" :disabled="isLoading">
                            <span v-if="isLoading == true" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                            S'enregistrer
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'RegisterView',
    data() {
        return {
            isLoading: false,
            form: {
                type: 'client'
            }
        }
    },
    methods: {
        register() {
            this.isLoading = true
            this.axios.post('/api/utilisateurs/'+this.$store.getters.user.id+'/update', this.form).then(response => {
                if (response.data.success === true) {
                    this.$router.push({ name: 'accueil' })
                    this.$store.commit('setUser', this.form)
                    this.resetForm()
                }
                else {
                    this.$toast.add({
                        severity: 'error',
                        detail: response.data.errors[0],
                        life: 5000
                    });
                }
                this.isLoading = false
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        resetForm() {
            this.form = {
                type: 'client'
            }
        }
    }
}
</script>
